import ky from "ky";
import qs from "query-string";
import snakecaseKeys from "snakecase-keys";

import { apiUrls } from "../../urls";
import { getCsrfToken } from "../../utils/getcsrftoken";
import { assertApiResponse } from "../utils/assertapiresponse";

import { parseSite, parseSites } from "./structs";

export type SearchSitesParams = {
    siteCode: string;
    siteName: string;
    lonFrom: number;
    lonTo: number;
    latFrom: number;
    latTo: number;
    elevationFrom: number;
    elevationTo: number;
    obsNetworkId: number[];
    installationSituationId: number[];
    avs30From: number;
    avs30To: number;
    d1100From: number;
    d1100To: number;
    d1400From: number;
    d1400To: number;
    d1700From: number;
    d1700To: number;
    d2100From: number;
    d2100To: number;
    dbaseFrom: number;
    dbaseTo: number;
};

/**
 * 観測点を検索する。
 *
 * @param params 検索条件
 * @returns 検索条件に該当する観測点情報
 */
export const searchSites = async (params?: Partial<SearchSitesParams>) => {
    const body = (params) ?
        new URLSearchParams(qs.stringify(snakecaseKeys(params), { arrayFormat: "comma" })) :
        undefined;

    const json = await ky
        .post(
            apiUrls["/sites/search"].post(),
            { body, headers: { "x-csrftoken": getCsrfToken() }, credentials: "same-origin", mode: "same-origin" })
        .json();

    assertApiResponse(json);

    if (json.result.status) {
        return parseSites(json.objects);
    } else {
        throw new Error(json.result.message);
    }
};

/**
 * 指定されたIDに対応する観測点情報を返す。
 *
 * @param siteId2 観測点ID
 * @returns 観測点情報
 */
export const getSite = async (siteId2: string) => {
    const json = await ky
        .get(
            apiUrls["/sites/[siteId2]"].get({ params: { siteId2 } }),
            { credentials: "same-origin", mode: "same-origin", throwHttpErrors: false })
        .json();

    assertApiResponse(json);

    if (json.result.status) {
        return parseSite(json.objects);
    } else {
        throw new Error(json.result.message);
    }
};
